import { render, staticRenderFns } from "./AvailabilityRegionRideTypeTariffList.vue?vue&type=template&id=7b142055&"
import script from "./AvailabilityRegionRideTypeTariffList.vue?vue&type=script&lang=js&"
export * from "./AvailabilityRegionRideTypeTariffList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports